// src/pages/ProjectsPage.js
import React from 'react';
import {
  Box, Heading, Text, VStack, SimpleGrid, Image, Tag,
  Breadcrumb, BreadcrumbItem, BreadcrumbLink, useColorModeValue
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import businessHubImage from '../assets/finance_building.webp';
import bridge_1 from '../assets/bridge_1.jpeg';
import bridge_2 from '../assets/river_bridge.webp';
import agarfa from '../assets/agarfa.webp';
import city_court from '../assets/city_court.webp';
import building from '../assets/building_.jpg';

const allProjects = [
    { title: 'Oromia Legal Research ang Training Institute', category: 'Commercial', image: building},
    { title: 'Bale Zone Finance Office Building', category: 'Commercial', image: businessHubImage },
    { title: 'Arba Bridge', category: 'Commercial', image: bridge_1 },
    { title: 'Obicha River Bridge', category: 'Commercial', image: bridge_2 },
    { title: 'Agarfa woreda Administration Office Building', category: 'Commercial', image: agarfa },
    { title: 'Adama City High Court Office B+G+4  Building', category: 'Commercial', image: city_court},
  
];

const ProjectGridCard = ({ title, category, image }) => (
    <VStack bg={useColorModeValue('white', 'gray.700')} borderRadius="lg" boxShadow="md" overflow="hidden" _hover={{ transform: 'translateY(-5px)', boxShadow: 'xl' }} transition="all 0.3s" align="flex-start">
        <Image src={image} alt={title} w="full" h="200px" objectFit="cover" />
        <VStack p={4} align="flex-start" spacing={2}>
            <Tag colorScheme="orange" size="sm">{category}</Tag>
            <Heading as="h3" size="md">{title}</Heading>
        </VStack>
    </VStack>
);

export default function ProjectsPage() {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  return (
    <>
      <Header />
      <Box as="main" bg={bgColor} py={{ base: 16, md: 24 }}>
        <VStack maxW="7xl" mx="auto" px={8} spacing={12}>
          <VStack spacing={4} textAlign="center">
            <Breadcrumb>
              <BreadcrumbItem>
                <BreadcrumbLink as={RouterLink} to="/">Home</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem isCurrentPage>
                <BreadcrumbLink href="#">Projects</BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
            <Heading as="h1" size="2xl">Our Portfolio</Heading>
          </VStack>
          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={10} w="full">
            {allProjects.map((project) => <ProjectGridCard key={project.title} {...project} />)}
          </SimpleGrid>
        </VStack>
      </Box>
      <Footer />
    </>
  );
}